// extracted by mini-css-extract-plugin
export var activeTags = "tag-module--activeTags--ab813";
export var tag = "tag-module--tag--3c490";
export var tagContainer = "tag-module--tagContainer--3a9df";
export var tagsContainer = "tag-module--tagsContainer--4c2f5";
export var tagsList = "tag-module--tagsList--3c85c";